import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'loyaltic-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalDialogComponent implements OnInit {

  @Input() modalId: string = 'modal-dialog';

  culture ='';

  constructor(public translate: TranslateService) { 
    this.culture = translate.getDefaultLang();
    this.culture = localStorage.getItem('currLanguage');
  }

  ngOnInit() {
  }

}
